function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 8.5,
  stroke: "#888FD1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.00078 4.2168C9.38738 4.2168 9.70078 4.5302 9.70078 4.9168V13.0835C9.70078 13.4701 9.38738 13.7835 9.00078 13.7835C8.61418 13.7835 8.30078 13.4701 8.30078 13.0835V4.9168C8.30078 4.5302 8.61418 4.2168 9.00078 4.2168Z",
  fill: "#888FD1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.21484 9.00078C4.21484 8.61418 4.52824 8.30078 4.91484 8.30078H13.0815C13.4681 8.30078 13.7815 8.61418 13.7815 9.00078C13.7815 9.38738 13.4681 9.70078 13.0815 9.70078H4.91484C4.52824 9.70078 4.21484 9.38738 4.21484 9.00078Z",
  fill: "#888FD1"
});

var SvgMultiSelectboxAdd = function SvgMultiSelectboxAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMultiSelectboxAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/multiSelectboxAdd.4ea972e6.svg";
export { ForwardRef as ReactComponent };